import React from 'react';

import theNewsLogo from '../../../../Assets/Linkages/WorldSpaceWeek/Media/the-news.ico';
import expressTribuneLogo from '../../../../Assets/Linkages/WorldSpaceWeek/Media/express-tribune.ico';
import urduPointLogo from '../../../../Assets/Linkages/WorldSpaceWeek/Media/urdupoint.png';
import dndLogo from '../../../../Assets/Linkages/WorldSpaceWeek/Media/dnd.png';
import abbTakkLogo from '../../../../Assets/Linkages/WorldSpaceWeek/Media/abbtakk.png';
import theNationLogo from '../../../../Assets/Linkages/WorldSpaceWeek/Media/the-nation.png';

const coverage = [
  {
    year: '2025',
    outlet: 'Associated Press of Pakistan',
    title: "Pakistan’s journey to the stars: IST celebrates World Space Week 2025 with a vision to inspire generations",
    url: 'https://www.app.com.pk/national/pakistans-journey-to-the-stars-ist-celebrates-world-space-week-2025-with-a-vision-to-inspire-generations/',
    logo: null,
  },
  {
    year: '2024',
    outlet: 'The Nation',
    title: 'World Space Week activities kick off',
    url: 'https://www.nation.com.pk/05-Oct-2024/world-space-week-activities-kick-off',
    logo: theNationLogo,
  },
  {
    year: '2024',
    outlet: 'The Express Tribune',
    title: 'IST kicks off World Space Week in Islamabad',
    url: 'https://tribune.com.pk/story/2501477/ist-kicks-off-world-space-week-inislamabad',
    logo: expressTribuneLogo,
  },
  {
    year: '2024',
    outlet: 'Abb Takk News',
    title: 'World Space Week celebrations commence',
    url: 'https://abbtakk.tv/world-space-week-celebrations-to-commence-today/',
    logo: abbTakkLogo,
  },
  {
    year: '2022',
    outlet: 'The News International',
    title: 'World Space Week celebrations',
    url: 'https://www.thenews.com.pk/print/992599-world-space-week-celebrations',
    logo: theNewsLogo,
  },
  {
    year: '2022',
    outlet: 'UrduPoint',
    title: 'Space festivity continues at IST under World Space Week banner',
    url: 'https://www.urdupoint.com/en/pakistan/space-festivity-continues-at-istunder-banner-1574563.html',
    logo: urduPointLogo,
  },
  {
    year: '2021',
    outlet: 'Dispatch News Desk',
    title: 'World Space Week 2021 kicks off at Institute of Space Technology',
    url: 'https://dnd.com.pk/world-space-week-2021-kicks-off-at-institute-of-space-technology/255105/',
    logo: dndLogo,
  },
];

const WorldSpaceWeekMediaCoverage = () => (
  <section className="summer-school-media world-space-week-media" aria-labelledby="world-space-week-media-title">
    <div className="summer-school-media-inner">
      <header className="summer-school-media-header">
        <p className="section-eyebrow">IN THE NEWS</p>
        <h2 id="world-space-week-media-title">Media Coverage</h2>
        <div className="world-space-week-title-line" aria-hidden="true" />
      </header>

      <div className="summer-school-media-grid">
        {coverage.map((article) => (
          <a
            className="summer-school-media-card"
            href={article.url}
            target="_blank"
            rel="noopener noreferrer"
            key={article.url}
            aria-label={`${article.title} — ${article.outlet}, ${article.year}`}
          >
            <div className="summer-school-media-logo-wrap">
              {article.logo ? (
                <img src={article.logo} alt={`${article.outlet} logo`} loading="lazy" />
              ) : (
                <span className="summer-school-media-logo-fallback" aria-hidden="true">APP</span>
              )}
            </div>
            <div className="summer-school-media-copy">
              <div className="summer-school-media-meta">
                <span>{article.outlet}</span>
                <time>{article.year}</time>
              </div>
              <h3>{article.title}</h3>
              <span className="summer-school-media-link">Read article <span aria-hidden="true">→</span></span>
            </div>
          </a>
        ))}
      </div>
    </div>
  </section>
);

export default WorldSpaceWeekMediaCoverage;
